import { sumValueFromDictKey, sumValueFromDictKeyFloat } from "../../../../utils/Helpers";

function useDataVizPercentage() {
  /**
   * Calculates the percentage of a selected channel within a set of metrics.
   *
   * @param {Array} metrics - An array of metric objects with 'name' and 'value' properties.
   * @param {string} selectedChannel - The name of the channel to calculate the percentage for.
   * @returns {string} The calculated percentage as a string, rounded to zero decimal places and without the '%' symbol.
   */
  const calculatePercentage = (metrics, selectedChannel, isFloatNumber = false) => {
    const channelValue = metrics.find((metric) => metric.name === selectedChannel)?.value || 0;
    let percentage = "";
    let totalValue = sumValueFromDictKey(metrics, "value") || 0;
    let channelValueNumber = parseInt(channelValue, 10);

    if (isFloatNumber) {
      totalValue = sumValueFromDictKeyFloat(metrics, "value") || 0;
      channelValueNumber = parseFloat(channelValue);
    }

    if (totalValue > 0) {
      percentage = ((channelValueNumber / totalValue) * 100).toFixed(0);
    }

    return percentage;
  };

  return { calculatePercentage };
}

export default useDataVizPercentage;
